import { Grid, Paper } from '@mui/material';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useGetUserInfoQuery } from '../services/api';
import ResponsiveAppBar from '../ResponsiveAppBar';

const Series = () => {
  const { data: user } = useGetUserInfoQuery();
  const navigate = useNavigate();
  useEffect(() => {
    if (user?.memberType !== 'public' && !user?.verified)
      navigate(`/verify${user?.verificationId
          ? `?verificationId=${user?.verificationId}`
          : ''
        }`
      )
  }, [navigate, user])

  if (!user)
    return null;

  return (
    <>
      <ResponsiveAppBar />
      <Paper
        style={{
          background: '#a0b1af',
          height: 'calc(100vh - 56px)',
          overflow: 'scroll',
          paddingBottom: 10,
          paddingTop: 10,
        }}
      >
        <Grid container>
          <Grid item xs={12}>
            :/
          </Grid>
        </Grid>
      </Paper>
    </>
  )
}

export default Series;
